import GameParameterInterface from '@/models/game/parameters/interface'

interface RouletteLotteryParameter {
  stopNumber: number,
  divideNumber: number,
  prize: RouletteGamePrize
}

export interface RouletteGamePrize {
  prizeImage: string,
}

export default class RouletteParameter implements GameParameterInterface {
  constructor(private parameter: RouletteLotteryParameter) { }

  createSetOption(): RouletteLotteryParameter {
    return {
      stopNumber: this.parameter.stopNumber,
      divideNumber: this.parameter.divideNumber,
      prize: this.parameter.prize,
    }
  }

  get guideUrl(): string {
    return '/'
  }
}
